import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as actions from './actions';

class AppWrapper extends Component {
  render() {
    const { children } = this.props;
    return <React.Fragment>{children}</React.Fragment>;
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  actions,
)(AppWrapper);



// WEBPACK FOOTER //
// ./src/AppWrapper.js